import React from 'react'
import * as SurveyJS from 'survey-react'
import EddrWrapper from './EddrWrapper'

const EddrWidget = {
  name: 'eddrwidget',
  title: 'eddrwidget',
  iconName: 'icon-default',
  widgetIsLoaded: function() {
    return true
  },
  isFit: function(question) {
    const applicableQuestions = ['XplorRequired_EddrCheck']

    return applicableQuestions.includes(question.name)
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('eddrwidget', [], null, 'text')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <EddrWrapper question={question} />
  }
}

export default EddrWidget
